import React from 'react';
import GameWalletsOverview from './GameWalletsOverview';

const GameWalletsManagement: React.FC = () => <GameWalletsOverview />;

export default GameWalletsManagement;
